import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import FileDownload from 'components/common/FileController/FileDownload';
import FileUpload from 'components/common/FileController/FileUpload';
import PreviewModal from './PreviewModal';
import { notification, Table, Button, Input, Checkbox } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

@inject(({ companyStore }) => ({
  companyMain: companyStore.companyMain,
  companyList: companyStore.companyList,
  saveCompanyList: companyStore.saveCompanyList
}))
@observer
class CompanyManageView extends Component {
  state = {
    companyMain: [],
    
    companyData: [],
    preview: false
  };
  
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.companyMain !== this.props.companyMain) {
      this.setState({companyMain: nextProps.companyMain});
    }

    if (nextProps.companyList !== this.props.companyList) {
      this.setState({companyData: nextProps.companyList});
    }
  }

  handleReset = (cpType) => {
    if (cpType === 'M') {
      this.setState({ companyMain: this.props.companyMain });
    } else {
      this.setState({ companyData: this.props.companyList });
    }
  };

  handleChange = (cpType, type, name, item, record, index) => {
    const funcChange = (value) => {
      if (cpType === 'M') {
        const newData = [...this.state.companyMain];
        newData.splice(index, 1, {
          ...record,
          [name]: value,
        });
        this.setState({companyMain: newData });
      } else {
        const newData = [...this.state.companyData];
        newData.splice(index, 1, {
          ...record,
          [name]: value,
        });
        this.setState({companyData: newData });
      }
    };

    const funcFileChange = (fileData) => {
      if (cpType === 'M') {
        const newData = [...this.state.companyMain];
        newData.splice(index, 1, {
          ...record,
          cpImgUrl: fileData.fileId,
          cpImgInfo: fileData,
        });
        this.setState({companyMain: newData });
      } else {
        const newData = [...this.state.companyData];
        newData.splice(index, 1, {
          ...record,
          cpImgUrl: fileData.fileId,
          cpImgInfo: fileData,
        });
        this.setState({companyData: newData });
      }
    };

    if (type === 'Input') {
      return (
        <Input
          value={item}
          onChange={(e)=>funcChange(e.target.value)}
          style={{ width: '100%' }}
        />
      )
    } else if (type === 'img') {
      return (
        <div style={{ display: "flex"}}>
          <FileUpload
            fileType={'img'}
            onFileInfo={(fileData)=>{
              if (fileData !== undefined && fileData !== null 
              && fileData.fileId !== undefined && fileData.fileId !== null) {
                funcFileChange(fileData);
              }
            }}
          />
          
          {cpType === 'M' 
          ? (this.state.companyMain[index].cpImgInfo !== undefined && this.state.companyMain[index].cpImgInfo !== null && 
            this.state.companyMain[index].cpImgUrl !== undefined && this.state.companyMain[index].cpImgUrl !== null && 
            this.state.companyMain[index].cpImgUrl !== '') &&
            <Fragment>
              <FileDownload
                fileInfoList={[this.state.companyMain[index].cpImgInfo]}
              />
            </Fragment>
          : (this.state.companyData[index].cpImgInfo !== undefined && this.state.companyData[index].cpImgInfo !== null && 
            this.state.companyData[index].cpImgUrl !== undefined && this.state.companyData[index].cpImgUrl !== null && 
            this.state.companyData[index].cpImgUrl !== '') &&
            <Fragment>
              <FileDownload
                fileInfoList={[this.state.companyData[index].cpImgInfo]}
              />
            </Fragment>
          }
        </div>
      )
    } else if (type === 'Checkbox') {
      return (
        <Fragment>
          <Checkbox
            checked={item === 'Y' ? true : false}
            onChange={(e)=>funcChange(e.target.checked ? "Y" : "N")}
          />
        </Fragment>
      )

    }
  };

  handleDelete = (cpType, key) => {
    if (cpType === 'M') {
      this.setState({ companyMain: this.state.companyMain.filter(item => item.RNUM !== key) });
    } else {
      this.setState({ companyData: this.state.companyData.filter(item => item.RNUM !== key) });
    }
  };

  handleAdd = (cpType) => {
    let newData = {
      RNUM: Date.now(),
      cpTabCd: "",
      cpType: cpType,
      cpTabNm: "",
      cpImgUrl: "",
      cpTabOrder: "",
      cpImgInfo: "",
      useYn: "",
    };
    if (cpType === 'M') {
      this.setState({ companyMain: [...this.state.companyMain, newData] });
    } else {
      this.setState({ companyData: [...this.state.companyData, newData] });
    }
  };

  handleSave = (cpType) => {
    if (cpType === 'M') {
      const { companyMain } = this.state;
      if (companyMain.length < 0) {
        notification.warning({placement: 'bottomLeft', message: `메인화면 이미지를 1개 이상 등록해주세요.`, duration: 2});
        return;
      }
      // 빈값 체크 Start
      let emptyChk = false;
      let emptyChkIdx = 0;
      let useYnChke = 0;
      companyMain.map((item, idx)=>{
        if (item.useYn === 'Y') { useYnChke++; }
        return (
        ((item.cpImgUrl === "") && emptyChk === false) &&
          (emptyChk = true,  emptyChkIdx = idx + 1)
      )});

      if (useYnChke !== 1) {
        notification.warning({placement: 'bottomLeft', message: `1개의 사용유무가 사용이여야 합니다.`, duration: 2});
        return false;
      }

      if (emptyChk === true) {
        notification.warning({placement: 'bottomLeft', message: `${emptyChkIdx}번 이미지를 확인하세요.`, duration: 2});
        return false;
      }
      // 빈값 체크 End
      const { cGbn } = this.props;
      this.props.saveCompanyList(cGbn === process.env.REACT_APP_TYPE_COMPANY_LGLOG ? "ML" : "M", companyMain);
    } else {
      const { companyData } = this.state;
      if (companyData.length < 0) {
        notification.warning({placement: 'bottomLeft', message: `회사안내정보를 1개 이상 등록해주세요.`, duration: 2});
        return;
      }
      // 빈값 체크 Start
      let emptyChk = false;
      let emptyChkIdx = 0;
      let useYnChke = 0;
      companyData.map((item, idx)=>{ 
        if (item.useYn === 'Y') { useYnChke++; }
        return (
        ((item.cpTabNm === "" ||  item.cpImgUrl === "") && emptyChk === false) &&
          (emptyChk = true,  emptyChkIdx = idx + 1)
      )});
  
      if (useYnChke < 1) {
        notification.warning({placement: 'bottomLeft', message: `1개 이상은 사용유무가 사용이여야 합니다.`, duration: 2});
        return false;
      }

      if (emptyChk === true) {
        notification.warning({placement: 'bottomLeft', message: `${emptyChkIdx}번 탭명 및 이미지를 확인하세요.`, duration: 2});
        return false;
      }
      // 빈값 체크 End
  
      //console.log(companyData);
      this.props.saveCompanyList("T", companyData);
    }
  };
  
  handleOrderChange = (type, item, record, index) => {
    const newData = [...this.state.companyData];

    if (type === 'up') {
      newData.splice(index, 1, newData[index-1]);
      newData.splice(index-1, 1, record);
      
    } else if (type === 'down') {
      newData.splice(index, 1, newData[index+1]);
      newData.splice(index+1, 1, record);
    }

    this.setState({
      companyData: newData
    });
  };

  render() {
    const { companyMain, companyData, preview } = this.state;
    const columnsMain = [
      { title: '삭제', dataIndex: '', key: '', width: '10%', align: 'center',
        render: (item, record) => { return(
          <Fragment key={record.RNUM}>
            <Button
              onClick={() => this.handleDelete('M', record.RNUM)}
            >삭제</Button>
          </Fragment>
        )}
      },
      { title: '이미지명', dataIndex: 'cpTabNm', key: 'cpTabNm', width: '30%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('M', 'Input', 'cpTabNm', item, record, index)
        )}
      },
      { title: '페이지상세이미지', dataIndex: 'cpImgNm', key: 'jobNm', width: '50%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('M', 'img', 'cpImgUrl', item, record, index)
        )}
      },
      { title: '사용유무', dataIndex: 'useYn', key: 'useYn', width: '10%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('M', 'Checkbox', 'useYn', item, record, index)
        )}
      }
    ];
    const columns = [
      { title: '삭제', dataIndex: '', key: '', width: '10%', align: 'center',
        render: (item, record) => { return(
          <Fragment key={record.RNUM}>
            <Button
              onClick={() => this.handleDelete('T', record.RNUM)}
            >삭제</Button>
          </Fragment>
        )}
      },
      { title: '탭명', dataIndex: 'cpTabNm', key: 'cpTabNm', width: '30%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('T', 'Input', 'cpTabNm', item, record, index)
        )}
      },
      { title: '페이지상세이미지', dataIndex: 'cpImgNm', key: 'jobNm', width: '30%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('T', 'img', 'cpImgUrl', item, record, index)
        )}
      },
      { title: '순서변경', dataIndex: '', key: '', width: '20%', align: 'center',
        render: (item, record, idx) => { return(
          <div key={record.key}>
            {idx !== 0 &&
              <Button 
                onClick={() => this.handleOrderChange('up', item, record, idx)}
              ><CaretUpOutlined /></Button>
            }
            {idx !== (this.state.companyData.length-1) &&
              <Button
                onClick={() => this.handleOrderChange('down', item, record, idx)}
              ><CaretDownOutlined /></Button>
            }
          </div>
        )}
      },
      { title: '사용유무', dataIndex: 'useYn', key: 'useYn', width: '10%', align: 'center',
        render: (item, record, index) => { return(
          this.handleChange('T', 'Checkbox', 'useYn', item, record, index)
        )}
      }
    ];

    return (
      <Fragment>
        <div className="button-group">
          <h2>▶ 사용자 메인화면 관리</h2>
          <div className="button-right">
            <ul>
              <li><Button onClick={()=>this.handleAdd('M')}>추가</Button></li>
              <li><Button onClick={()=>this.handleReset('M')}>초기화</Button></li>
              <li><Button type="primary" onClick={()=>this.handleSave('M')}>저장</Button></li>
            </ul>
          </div>
        </div>

        <Table
          rowClassName={() => 'editable-row'}
          bordered
          rowKey={(record)=>record.RNUM}
          columns={columnsMain} 
          dataSource={companyMain}
          pagination={false}
          scroll={{ y: 400 }}
        />

        <div className="button-group">
          <h2>▶ 회사안내 정보 관리</h2>
          <div className="button-right">
            <ul>
              <li><Button onClick={()=>this.handleAdd('T')}>추가</Button></li>
              <li><Button onClick={()=>this.handleReset('T')}>초기화</Button></li>
              <li><Button onClick={()=>this.setState({preview: true})}>미리보기</Button></li>
              <li><Button type="primary" onClick={()=>this.handleSave('T')}>저장</Button></li>
            </ul>
          </div>
        </div>

        <Table
          rowClassName={() => 'editable-row'}
          bordered
          rowKey={(record)=>record.RNUM}
          columns={columns} 
          dataSource={companyData}
          pagination={false}
          scroll={{ y: 400 }}
        />

        <PreviewModal
          modalOpen={preview}
          modalClose={()=>this.setState({preview: false})}
          companyData={companyData}
        />

      </Fragment>
    );
  }

}

export default withRouter(CompanyManageView);
